'use strict'
module.exports = require('./lib')(require('./lib/elliptic'))



//////////////////
// WEBPACK FOOTER
// ./node_modules/secp256k1/elliptic.js
// module id = 31
// module chunks = 0